import Pricing from '../shared/pricing/pricing'
import {Zendesk} from '../services/zendesk'

tag gifts-page
	prop authFormVisible = no
	prop payButtons = no
	prop cardError = ""
	prop paymentRequest
	prop stripe
	prop storeReady = no
	prop card
	prop use-usd

	prop loading = no
	css mb:50px
	css .table
		.row d:hflex lh:1.8 fs:lg
		.row .desc fl:1
		.neg c:orange8
		.totals,.coupon
			bdt:1px solid gray6/30 fw:700 mt:2 pt:2
		.coupon .desc c:orange8

	css .button-group
		d:hgrid bg:blue2/10 rd:md bxs:inset 0 0 0 1px blue5
		.item d:hflex ja:center p:3 rd:inherit fw:bold c:blue7
		.checked bg:blue5 c:white

	css .mark-yellow pos:relative zi:2 c:orange8 fs:lg py:2px px:4px 
		@before pos:absolute inset:0 my:1 bg:yellow4 content:" " d:block zi:-1 rotate:-2deg scale-x:1.1

	css .plan-options
		d:hflex rd:lg bg:gray3 # bxs:inset 0 0 0 1px gray4 
		.option
			w:30% fl:1 ta:center p:2 d:vflex ja:center rd:inherit
			bd:1px solid clear
			.name fs:xl mb:-1
			.price fs:lg
				@after
					content: "/month" o:0.5 ml:0.2 fs:xs
			&.checked bg:blue5 c:white my:-1 py:3 bc:blue7
				.name fw:bold

	css .tab-group
		d:hflex bdb:1px solid gray6/30 pos:relative
		.item d:hflex ja:center py:2 fw:bold c:gray6 mb:-1px rdt:md bdb:1px solid clear mr:4
		.checked2 bg:blue5 c:white bc:blue7
		.checked bc:blue7 c:blue7 pe:none
		@after d:block content:" " pos:absolute 

	css .field
		w:100% py:3 px:3 rd:md bd:1px solid bc:gray4 fs:md outline:none
		ff:inherit font-style:inherit fw:inherit bg:white
		@focus bxs:glow bc:blue4

	css .usps
		li py:2 ta:center
		h4 mb:0 font-style:italic fs@lt-lg:1.25rem
		p c:gray7

	css fieldset 
		label fs:sm mb:1
		input p:2
		p:0 mb:3 mx:0

	css .foot
		d:vflex ai:flex-end mt:6
		button mb:15px

	css .card-form
		d:none

	css .hide-element
		d:none
	
	css .show-element
		d:block

	css form.busy
		o:0.5 pe:none
	
	css $box
		bxs:xl rd:xl bg:white d:hflex ai:stretch p:0 of:hidden
	
	css self header
		pos:absolute w:100% t:0 h:100px ta:center zi:4  d:none @400:vflex ja:center
		h3 ta:center rotate:-1deg c:orange8 ls:-1px mt:8
		
	css .section w:100% d:vflex ja:center p:10 pos:relative fl: 1 1 auto pt:25px max-width:500px min-height:480px
		@after content:" " d:block max-height:120px fl:1 1 auto

	css .usp bg:indigo2/80 c:indigo9 rd:md p:4 ta:center font-style:italic d:hflex j:center a:center
	css .payment d:grid gtc:1fr @sm:1fr 1fr @lg:1fr 1fr 1fr 1fr grid-gap:15px mt:8 tween: all 0.2s linear
	css .payment.methods gtc:1fr @sm:1fr 1fr

	pricing = new Pricing({pricing: store.me..pricing, coupons: store.me..coupons, subscription: store.subscription})

	prop authFormVisible = no
	prop stripe
	prop use-usd = no
	
	get default-plan do 'annual'
	prop selected-plan-id = default-plan

	get selected-plan do pricing[selected-plan-id]
	
	prop gift-coupons = []
	
	prop pricing = new Pricing({
		pricing: store.me..pricing
		country: store.me..country
		coupons: gift-coupons # Remove free trial coupons
		subscription: store.subscription})
	
	get price-type do use-usd ? 'usd' : 'local'
	get currency do price-type == 'usd' ? 'usd' : pricing.currency

	get plan-price-usd do selected-plan.price.usd.plan
	get plan-price do price-type == 'usd' ? plan-price-usd : selected-plan.price.plan
	get coupon do selected-plan..coupon

	get cid
		try
			let gaTrackers = window.ga.getAll!
			gaTrackers[0].get('clientId') if gaTrackers
		catch err
			''

	css .grid d: grid

	def toggleAuthForm sum
		if authFormVisible == no and window.location.hostname == 'scrimba.com'
			let url = window.location.href.indexOf('#') > -1 ? window.location.href.split('#')[0] : window.location.href
			api.track('Subscriptions', 'GoToPayment Clicked', url)
		authFormVisible = !authFormVisible

	def payWithStripeCheckout
		let params =
			product_name: selected-plan.id
			purchase_url: window.location.href.indexOf('#') > -1 ? window.location.href.split('#')[0] : window.location.href
			coupon_code: coupon ? coupon.code : no
			use_usd: use-usd
			cid: cid
			gift: true

		let res = await api.post("/stripe/subscription/gift", params)
		if res.message
			imba.mount <app-snackbar data=res>

		if res.code == 200
			return stripe.redirectToCheckout(sessionId: res.session)

	def authenticate e
		let action = signin ? '/auth/login' : '/auth/signup'
		let params = Object.fromEntries(new FormData($form))

		let res = await api.post(action,params)
		if res
			if res.message
				imba.mount <app-snackbar data=res>

			if res.code < 400
				await window.reloadUserData!

			return res

	def hydrate
		innerHTML = ''
		schedule!
		if store..me..coupons
			gift-coupons = store.me.coupons.filter do !$1.plans.includes('trialweek') 
		use-usd = window.location.href.indexOf('use_usd') > -1 ? yes : no

		pricing = new Pricing
			pricing: store.me..pricing
			country: store.me..country
			coupons: gift-coupons # Remove free trial coupons
			subscription: store.subscription
			usd: use-usd
		window.$once('stripe').then do stripe = Stripe(store.stripeKey)
		window.zendesk ||= new Zendesk 
		render!

	get header-promo-text
		if selected-plan.discounted?
			<>
				"Limited discount: "
				<span[td:line-through]> selected-plan.reference.plan_text
				<span> " {selected-plan.price.plan_text} for {selected-plan.duration}!"
		else
			<>
				"Go pro for only "
				<span> " {selected-plan.price.plan_text} for {selected-plan.duration}!"

	def render
		return if $node$
		return if pricing.loading?

		<self>
			<h2[mt:70px ta:center]> "Buy Scrimba subscriptions as a gift 🎁"
			<header[mt:130px @700:100px]>
				<h3> header-promo-text
			<.content[d:vflex @700:hflex jc:center ai:center my:6 mt:120px]>
				<.section.copy>
					<ul.usps>
						<li>
							<h4.bold> "One-time purchase"
							<p> "Give a membership without worrying about future payments"
						<li>
							<h4.bold> "30-day money-back guarantee"
							<p> "No questions asked, full refund within 24 hours"
						<li>
							<h4.bold> "Does not expire"
							<p> "Our gift vouchers do not expire"
						<li>
							<h4.bold> "Access ALL our content"
							<p> "Take all our courses, including the Frontend Developer Career Path"
						<li>
							<h4.bold> "Easy to use"
							<p> "Just send a link and your recipient is good to go!"
						
				<.section[bg:purple2]>
					<svg[mb: 0.75em] src="svg/peeps-challenge.svg" loading="lazy">
					<div[m:auto as:stretch w:100%]>
						<.hide-element=(authFormVisible)>
							<h4.bold[ta:left mb:0]> "Choose your plan"
							<select.plans.field[mb:2] bind=selected-plan-id> for item in pricing.available-plans
								<option value=item.id> 
									"{item.name} - {item.price.plan_text} {item.interval_count > 1 ? "(Per month: {item.price.monthly_text})" : ""}"

						# <p[ta:left mt:4]> "Choose payment method"
						# 	<.tab-group[mb:3]>
						# 		<button.item bind=processor value='stripe'> "Credit/Debit card"
						<div[my:6]> ""
						<.receipt.table[mt:2 mb:2]>
							<.row>
								<.desc> "{selected-plan.interval_count} month{selected-plan.interval_count == 1 ? '' : 's'} x {selected-plan.reference.monthly_text}"
								<.sum> selected-plan.reference.plan_text
							<.row .neg[fw:700]>
								<.desc[d:vflex]>
									<span> "Your discount"
								<.sum> "-" + selected-plan.discount.value_text

							<p.small.neg[ my:0 fw:thin]> selected-plan.discount.text_text

							<.row.totals>
								<.desc>
									"Total"

								<span.save.mark-yellow[mr:4]> "{selected-plan.discount.percent_text}% off" if selected-plan.discounted?
								<.sum> selected-plan.price.plan_text


							<.foot>
								<button[mx:0 d@guest:none].button.md @click.prevent.throttle.flag-busy=payWithStripeCheckout(plan-price)>
									<b> "Continue with payment"
								<button[mx:0 d:none d@guest:block].button.md @click.prevent.throttle.flag-busy=toggleAuthForm(plan-price)>
									<b> "Continue with payment"

								<p.small[c:gray7]> 
									"Payment problems or questions? Follow "
									<a.link.small target="blank" href="https://scrimba.com/links/payment-troubleshoot"> "this guide"
									" or "
									<a.link.small target="blank" @click=window.zendesk.open> "talk to us"

					<.hide-element=!(authFormVisible)>
						<form$form[w:300px mx:auto mt:4 d:none d@guest:block] action='/auth/signup' @submit.prevent.throttle.flag-busy=authenticate>
							<h4.bold[font-style:italic ta:center]> signin ? "Log in" : "Create your account" 
							<div[d:vgrid g:2]>
								<input type='email' name='email' placeholder='Email' autocomplete='email' required>
								<input type='password' name='password' autocomplete="new-password" placeholder='Password' required>
								<button.button.neutral[ w:100%] type='submit'> signin ? "Log in" : "Create Account"
								<.group-head[my:1 c:gray6]> <p.small> "or"
								<a.button[w:100%] href="/auth/github?from={store.url.pathname}%23join"> "Sign {signin ? "in" : "up"} with GitHub"
								<p.small[mt:4 c:red8]>
									"Having issues signing in? "
									<a.small href="https://www.google.com/search?q=clear+cookies" target="_blank"> "Clearing your cookies will resolve it"
							if signin
								<p.small[mt:3 c:gray7]>
									"Don't have an account? "
									<a[ml:1].link.small @click=(signin = no)> "Sign up"
							else
								<p.small[mt:3 c:gray7]>
									"Already have an account? "
									<a[ml:1].link.small @click=(signin = yes)> "Log in"
							<div.busy-cover>

